module.exports = __webpack_public_path__ + "static/media/ChattyWay.cc288800.svg";